import { render, staticRenderFns } from "./RedeemptionRequestList.vue?vue&type=template&id=dca84c28&scoped=true"
import script from "./RedeemptionRequestList.vue?vue&type=script&lang=js"
export * from "./RedeemptionRequestList.vue?vue&type=script&lang=js"
import style0 from "./RedeemptionRequestList.vue?vue&type=style&index=0&id=dca84c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca84c28",
  null
  
)

export default component.exports